import React from 'react';
import { useIntl } from 'react-intl';
import { Selector, SelectorOptionPropsInterface } from 'sonata-react-components';
import {
  businessSolution,
  channel,
  mainCampaignKPI
} from 'sonata-static-storage/lib/samples/campaignSettingsDictionaries.samples';

type Props = {
  campaignBusinessSolution: string;
  campaignChannel: string;
  campaignMainCampaignKPI: string;
  onBusinessSolutionChange: (solution: string) => void;
  onChannelChange: (channel: string) => void;
  onKpiChange: (kpi: string) => void;
};

const CampaignStrategy: React.VFC<Props> = ({
  campaignBusinessSolution,
  campaignChannel,
  campaignMainCampaignKPI,
  onBusinessSolutionChange,
  onChannelChange,
  onKpiChange
}) => {
  const { formatMessage } = useIntl();

  const onChangeConfig = (option: SelectorOptionPropsInterface, property: string) => {
    switch (property) {
      case 'businessSolution':
        onBusinessSolutionChange(option.id.toString());
        break;
      case 'mainCampaignKPI':
        onKpiChange(option.id.toString());
        break;
      case 'channel':
        onChannelChange(option.id.toString());
        break;
      default:
    }
  };

  const businessSolutionOptions: SelectorOptionPropsInterface[] = [
    ...businessSolution.map(value => ({
      id: value,
      label: formatMessage({
        defaultMessage: value,
        id: `campaignStrategy.businessSolution.${value}`
      })
    }))
  ];

  const mainCampaignKPIOptions: SelectorOptionPropsInterface[] = [
    ...mainCampaignKPI.map(value => ({
      id: value,
      label: formatMessage({
        defaultMessage: value,
        id: `campaignStrategy.mainCampaignKPI.${value}`
      })
    }))
  ];

  const channelOptions: SelectorOptionPropsInterface[] = [
    ...channel.map(value => ({
      id: value,
      label: formatMessage({
        defaultMessage: value,
        id: `campaignStrategy.channel.${value}`
      })
    }))
  ];

  return (
    <>
      <Selector
        className="campaignStrategy__businessSolutionSelector"
        label={formatMessage({
          defaultMessage: 'Business Solution',
          id: 'campaignStrategy.businessSolution.label'
        })}
        onChange={(option: SelectorOptionPropsInterface) => onChangeConfig(option, 'businessSolution')}
        options={businessSolutionOptions}
        showDeselectOption
        showSearch
        type="simple"
        value={
          campaignBusinessSolution
            ? [
                {
                  id: campaignBusinessSolution,
                  label: formatMessage({
                    defaultMessage: campaignBusinessSolution,
                    id: `campaignStrategy.businessSolution.${campaignBusinessSolution}`
                  })
                }
              ]
            : []
        }
      />
      <Selector
        className="campaignStrategy__mainCampaignKPISelector"
        label={formatMessage({
          defaultMessage: 'Main Campaign KPI',
          id: 'campaignStrategy.mainCampaignKPI.label'
        })}
        onChange={(option: SelectorOptionPropsInterface) => onChangeConfig(option, 'mainCampaignKPI')}
        options={mainCampaignKPIOptions}
        showDeselectOption
        showSearch
        type="simple"
        value={
          campaignMainCampaignKPI
            ? [
                {
                  id: campaignMainCampaignKPI,
                  label: formatMessage({
                    defaultMessage: campaignMainCampaignKPI,
                    id: `campaignStrategy.mainCampaignKPI.${campaignMainCampaignKPI}`
                  })
                }
              ]
            : []
        }
      />
      <Selector
        className="campaignStrategy__channelSelector"
        label={formatMessage({
          defaultMessage: 'Channel',
          id: 'campaignStrategy.channel.label'
        })}
        onChange={(option: SelectorOptionPropsInterface) => onChangeConfig(option, 'channel')}
        options={channelOptions}
        showDeselectOption
        showSearch
        type="simple"
        value={
          campaignChannel
            ? [
                {
                  id: campaignChannel,
                  label: formatMessage({
                    defaultMessage: campaignChannel,
                    id: `campaignStrategy.channel.${campaignChannel}`
                  })
                }
              ]
            : []
        }
      />
    </>
  );
};

export default CampaignStrategy;
